module.exports = __webpack_public_path__ + "static/media/Gluten Free.ebcda9ac.jpg";